import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { Provider } from 'react-redux'
import { GlobalOptions } from 'shared/types'
import { Paths, UserRole } from 'shared/constants'
import PrivateRoute from '../private-route/private-route'
import Page from '../page/page'
import store from '@m/store/store'

const HomeApp = React.lazy(async () => import('home/Home'))
const LoginApp = React.lazy(async () => import('login/Login'))
const PolicySearchApp = React.lazy(async () => import('policySearch/PolicySearch'))
const ReportsApp = React.lazy(async () => import('reports/Reports'))
const ProfileApp = React.lazy(async () => import('profile/Profile'))
const ProgramsApp = React.lazy(async () => import('programs/Programs'))
const CalculatorApp = React.lazy(() => import('calculator/Calculator'))
const AgentsApp = React.lazy(() => import('agents/Agents'))
const PrePaymentApp = React.lazy(() => import('prePayment/PrePayment'))

interface AppProps {
  globalOptions: GlobalOptions
}

const App: FC<AppProps> = () => {
  return (
    <>
      <Provider store={store}>
        <React.Suspense fallback={'Загрузка модуля...'}>
          <Routes>
            <Route element={<Page />}>
              <Route
                index
                element={
                  <PrivateRoute>
                    <HomeApp />
                  </PrivateRoute>
                }
              />
              <Route
                path={Paths.ProfileApp}
                element={
                  <PrivateRoute>
                    <ProfileApp />
                  </PrivateRoute>
                }
              />
              <Route
                path={Paths.AgentsApp}
                element={
                  <PrivateRoute allowedRole={[UserRole.Admin]}>
                    <AgentsApp />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${Paths.CalculatorApp}`}
                element={
                  <PrivateRoute
                    allowedRole={[UserRole.AgentAdmin, UserRole.Manager, UserRole.Seller]}
                  >
                    <CalculatorApp />
                  </PrivateRoute>
                }
              />
              <Route
                path={Paths.ReportsApp}
                element={
                  <PrivateRoute
                    allowedRole={[UserRole.AgentAdmin, UserRole.Manager, UserRole.Seller]}
                  >
                    <ReportsApp />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${Paths.PolicySearchApp}/*`}
                element={
                  <PrivateRoute>
                    <PolicySearchApp />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${Paths.ProgramsApp}`}
                element={
                  <PrivateRoute
                    allowedRole={[UserRole.AgentAdmin, UserRole.Manager, UserRole.Seller]}
                  >
                    <ProgramsApp />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route path={Paths.LoginApp} element={<LoginApp />} />
            <Route path={Paths.PrePaymentApp} element={<PrePaymentApp />} />
          </Routes>
        </React.Suspense>
      </Provider>
    </>
  )
}

export default App
